export const BLOG_ARTICLE_CONTENT_TYPE = 'blog-article'
export const BLOG_ARTICLE_CATEGORY_CONTENT_TYPE = 'blog-article-category'

export const BLOG_ARTICLE_TEASERS_PAGE_PROP = '_blogArticleTeasers'
export const BLOG_ARTICLE_CATEGORIES_PAGE_PROP = '_blogArticleCategories'

export const BLOG_ARTICLE_LIST_BLOCK = 'blogArticleList'
export const BLOG_ARTICLE_CATEGORY_LIST_BLOCK = 'blogArticleCategoryList'
